// Operation names the Apollo link chain in src/core/api.ts needs to reference
// without taking on the chat component implementation files.
//
// Both queries fire once per channel render — high fan-out (a chat-list mount
// issues one of these per channel), not a polling loop — and are
// intentionally filtered from Sentry breadcrumbs and excluded from RetryLink:
// one transient failure should not trigger N parallel retry chains.
export const getChannelListItemUserOperation = 'getChannelListItemUser';
export const getChatHeaderUserOperation = 'getChatHeaderUser';
